<template>
  <div class="text-left flex flex-col text-textPrimary">
    <div class="flex items-center gap-3 mb-1">
      <div
        v-if="mainId"
        class="flex items-center bg-gray-50 rounded-lg border border-gray-100 p-1 shadow-sm"
        :class="secondaryId ? 'pr-3' : 'px-3'"
      >
        <div class="flex flex-col" :class="{ 'px-2 border-r border-gray-200 mr-2': secondaryId }">
          <span class="text-[10px] text-gray-400 uppercase font-bold leading-none">{{
            typeLabel
          }}</span>
          <span class="text-sm font-medium text-gray-500 leading-tight">#{{ mainId }}</span>
        </div>

        <template v-if="secondaryId">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-400 mx-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>

          <div class="flex items-center gap-1">
            <span class="text-xl font-bold text-gray-700">#{{ secondaryId }}</span>
          </div>
        </template>
      </div>

      <strong class="font-bold text-2xl text-textPrimary leading-tight">
        {{ title }}
      </strong>
    </div>

    <div v-if="breadcrumbsText" class="text-base text-gray-500">
      {{ breadcrumbsText }}
    </div>
    <div
      v-else-if="breadcrumbsList && breadcrumbsList.length > 0"
      class="flex flex-wrap items-center mt-1 text-sm text-gray-500"
    >
      <template v-for="(item, index) in breadcrumbsList" :key="index">
        <span>{{ item }}</span>
        <span v-if="index < breadcrumbsList.length - 1" class="mx-1"> &gt; </span>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { ShiftDetails } from '@/Network/Types/Responses/StationResponses'

const props = defineProps<{
  stationDetails?: ShiftDetails | null
  resourceType?: string
  resourceId?: number | string
  headerTitle?: string
  breadcrumbs?: string[]
}>()

const isStation = computed(() => !!props.stationDetails)

const typeLabel = computed(() => {
  if (isStation.value) return 'Estação'
  return props.resourceType || 'Recurso'
})

const mainId = computed(() => {
  if (isStation.value) return props.stationDetails?.id
  return props.resourceId
})

const secondaryId = computed(() => {
  if (isStation.value) return props.stationDetails?.doctorStation?.id
  return null
})

const title = computed(() => {
  if (props.headerTitle) return props.headerTitle
  return 'Detalhes do Plantão'
})

const breadcrumbsText = computed(() => {
  if (isStation.value && props.stationDetails) {
    const s = props.stationDetails
    return `${s.schedule?.healthUnit?.company?.name || 'Companhia'} > ${s.schedule?.healthUnit?.name || 'Unidade de Saúde'} > ${s.schedule?.name || 'Escala'} > ${s.position?.name || 'Posição não definida'}`
  }
  return null
})

const breadcrumbsList = computed(() => props.breadcrumbs || [])
</script>
